import styled from "styled-components";

const Separator = styled.div`
  height: 1px;
  background-color: ${({ theme }) => theme.colors.grey[300]};
  flex-shrink: 0;
`;

export default Separator;
